import React, { Component, createRef } from 'react';
import { createPortal } from 'react-dom';

import { element, number, object } from 'prop-types';
import Swipe from 'react-easy-swipe';

import './hamburger-menu.scss';

import { HamburgerMenuAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { arrayOf, eventListener, oneOfType, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { classNames, getViewportElement, isFunction } from '@philips-emr/tws-utils';

import { Menu, MenuIcon } from '../..';

@AwesomeComponent({ type: ComponentType.NAVIGATION, api: HamburgerMenuAPI })
class HamburgerMenu extends Component {
  constructor(props) {
    super(props);

    this.iconRef = createRef();

    this.state = {
      open: false,
    };
  }

  static propTypes = {
    baseName: string.readOnly(),
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    className: string,
    data: arrayOf(object).readOnly(),
    onBeforeClose: eventListener,
    onClose: eventListener,
    onOpen: eventListener,
    topOffset: number,
    uuid: string,
  };

  static defaultProps = {
    topOffset: 50,
  };

  shouldClose = () => {
    if (!this.state.open) {
      return;
    }
    let close = true;

    const abortFn = () => close = false;
    const { onBeforeClose } = this.props;

    onBeforeClose({ abort: abortFn });

    return close;
  };

  onIconClick = () => {
    const { open } = this.state;
    const { onClose, onOpen } = this.props;

    let triggerEvent;

    if (open) {
      if (!this.shouldClose()) {
        return;
      }

      triggerEvent = () => isFunction(onClose) && onClose();
    } else {
      triggerEvent = () => isFunction(onOpen) && onOpen();
    }

    this.setState(({ open }) => ({ open: !open }), triggerEvent);
  };

  onSwipeLeft = () => {
    this.setState({ open: false });
  };

  getClassName() {
    const { className } = this.props;

    return classNames({
      'c-hamburger-menu': true,
      [className]: Boolean(className),
    });
  }

  renderOpenContent() {
    const { topOffset } = this.props;
    const { open } = this.state;

    if (!open) {
      return null;
    }

    const element = getViewportElement();

    const scrollHeight = document.documentElement.scrollHeight;
    const contentStyle = {
      top: `${topOffset}px`,
      height: `${scrollHeight - topOffset}px`,
    };

    const content = (
      <Swipe className="c-menu__swipe-wrapper" onSwipeLeft={this.onSwipeLeft} tolerance={100}>
        <div className="c-hamburger-menu__content" style={contentStyle}>
          {this.renderMenu()}
        </div>
      </Swipe>
    );

    return createPortal(content, element);
  }

  renderHeader() {
    return (
      <div className="c-hamburger-menu__header" ref={this.iconRef}>
        {this.renderIcon()}
      </div>
    );
  }

  renderIcon() {
    const { open } = this.state;

    if (open) {
      return null;
    }

    return <MenuIcon onClick={this.onIconClick} />;
  }

  renderMenu() {
    const { children, ...otherProps } = this.props;
    const { open } = this.state;

    if (!open) {
      return null;
    }

    return (
      <Menu
        {...otherProps}
        className="c-hamburger-menu__menu"
        iconTarget={this.iconRef}
        onClose={this.onIconClick}
        showHeader
      >
        {children}
      </Menu>
    );
  }

  render() {
    return (
      <div className={this.getClassName()}>
        {this.renderOpenContent()}
        {this.renderHeader()}
      </div>
    );
  }
}

export default HamburgerMenu;
